export default "__VITE_ASSET__BlARWQun__"